import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSubscriptionService {
  private behaviorData = new BehaviorSubject<any>({});
  private data = new Subject<any>();
  private _onScroll: () => void;

  constructor() {}

  initOnScroll(fn: () => void) {
    this.onScroll = fn;
  }

  onScroll() {
    this._onScroll();
  }

  getData(): Observable<any> {
    return this.data.asObservable();
  }

  getBehaviorData(): Observable<any> {
    return this.behaviorData.asObservable();
  }

  publishData(event: string, data: any): void {
    this.data.next({
      event: event,
      data: data
    });
  }

  publishBehaviorData(event: string, data: any): void {
    this.behaviorData.next({
      event: event,
      data: data
    });
  }

  publishEvent(event: string, data?: any): void {
    this.publishData(event, data);
  }
}
